export function objectJSON(value) {
  if (!value) return {};
  else return typeof value === "string" ? JSON.parse(value) : value;
}
